module.exports = __webpack_public_path__ + "img/banner.6c41adb8.jpg";